import LabelDesigner from './src/index.vue';

/* istanbul ignore next */
LabelDesigner.install = function (Vue) {
    Vue.component(LabelDesigner.name, LabelDesigner);
};

export default LabelDesigner;